module.exports = __webpack_public_path__ + "static/media/Optimal-Online-Logo.a27bd51c.svg";